import { useEffect } from "react";
import confetti from "canvas-confetti";
import { LockOpen } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const COLORS = ["#F2B24C", "#E06D53", "#FFD27A", "#B08D57", "#F7A38B"];

const burst = () => {
  const end = Date.now() + 1800;
  const frame = () => {
    confetti({ particleCount: 5, angle: 60, spread: 70, origin: { x: 0, y: 0.7 }, colors: COLORS, zIndex: 9999 });
    confetti({ particleCount: 5, angle: 120, spread: 70, origin: { x: 1, y: 0.7 }, colors: COLORS, zIndex: 9999 });
    if (Date.now() < end) requestAnimationFrame(frame);
  };
  confetti({ particleCount: 120, spread: 100, origin: { y: 0.45 }, colors: COLORS, zIndex: 9999 });
  frame();
};

export const UnlockCelebration = ({ open, onOpenChange }) => {
  useEffect(() => {
    if (open && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) burst();
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="unlock-celebration" className="border-0 bg-gradient-to-br from-[#FFF4D6] via-[#FFE9C2] to-[#FFDDB5] text-center sm:max-w-md">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#E06D53] text-white shadow-lg">
          <LockOpen size={32} weight="fill" />
        </div>
        <DialogTitle data-testid="unlock-celebration-title" className="font-serif text-3xl text-[#2C2A28]">
          Welcome to Lifetime Access
        </DialogTitle>
        <DialogDescription data-testid="unlock-celebration-text" className="text-base leading-relaxed text-[#5A3A10]">
          Every Life Season is now unlocked. Record unlimited memories for life.
        </DialogDescription>
        <button
          data-testid="unlock-celebration-close"
          onClick={() => onOpenChange(false)}
          className="mx-auto mt-2 rounded-full bg-[#E06D53] px-8 py-3 text-base font-semibold text-white shadow-md transition-transform hover:scale-[1.03]"
        >
          Start exploring my seasons
        </button>
      </DialogContent>
    </Dialog>
  );
};
